<div class="nowrap" ng-class="$ctrl.itemClasses()">
    <div class="text" title="{{ $ctrl.tooltip() }} ">{{ $ctrl.item.text }} <span ng-if="$ctrl.item.info" class="info">({{ $ctrl.item.info }})</span></div><span ng-click="$ctrl.clearButtonClick()" class="clear">&times;</span>
</div>